import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_bev_12: FaireProductEntity = {
  token: "nyc-bev-12",
  type: "product",
  name: "Williamsburg Matcha Latte Mix",
  brandName: "Brooklyn Tea House",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
  priceDollars: 14.5,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/2a6ca115955ee7fa0eb159e8c05c4d0b6e9cdaeef8fa05a6b8d467e6dc39cd09.webp",
  weight: 0.8,
  dimensions: {
    width: 4,
    height: 6,
    depth: 2,
  },
  description: "Premium matcha latte mix from Williamsburg",
  categoryTokens: ["cat_food-beverages"],
  tags: ["nyc-local", "premium", "organic", "tea", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
